import { FaWhatsapp } from 'react-icons/fa';
import { colors } from '../../colors';
import {
  container,
  descriptionText,
  iconBackground,
  titleText,
  cardDescriptionText,
  cardTitleText,
  button,
  leftContainer,
  rightContainer,
  rightInnerContainer,
} from './ComoFunciona.styles';
import { SlDiamond } from 'react-icons/sl';
import { handleOpenLink } from '../../utils/common';

export default function ComoFunciona() {
  return (
    <section className={container}>
      <div className={leftContainer}>
        <p className={titleText}>O que é a perfiloplastia?</p>
        <p className={descriptionText}>
          Perfiloplastia é um conjunto de procedimentos estéticos que busca
          equilibrar o perfil facial, realçando a harmonia entre nariz, lábios e
          queixo.
        </p>
        <p className={descriptionText}>
          O objetivo é valorizar a beleza individual de forma natural e sem
          exageros. Esses ajustes estratégicos, realizados com ácido
          hialurônico, proporcionam projeção, definição e equilíbrio,
          respeitando as características únicas de cada rosto e conferindo um
          perfil mais sofisticado e harmônico.
        </p>

        <button
          onClick={() =>
            handleOpenLink(
              'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
              'agendar_consulta_click',
              'Agendar consulta',
              window.location.pathname
            )
          }
          className={button}
        >
          <FaWhatsapp /> Agendar consulta
        </button>
      </div>
      <div className={rightContainer}>
        <div className={rightInnerContainer}>
          <div className={iconBackground}>
            <SlDiamond size={20} color={colors.background} />
          </div>
          <div>
            <p className={cardTitleText}>Resultados Naturais</p>
            <p className={cardDescriptionText}>
              Traços realçados de forma sutil e harmoniosa.
            </p>
          </div>
        </div>
        <div className={rightInnerContainer}>
          <div className={iconBackground}>
            <SlDiamond size={20} color={colors.background} />
          </div>
          <div>
            <p className={cardTitleText}>Proporção e Harmonia</p>
            <p className={cardDescriptionText}>
              Perfil equilibrado e elegante.
            </p>
          </div>
        </div>
        <div className={rightInnerContainer}>
          <div className={iconBackground}>
            <SlDiamond size={20} color={colors.background} />
          </div>
          <div>
            <p className={cardTitleText}>Beleza Autêntica</p>
            <p className={cardDescriptionText}>
              Aparência valorizada de forma natural.
            </p>
          </div>
        </div>
        <div className={rightInnerContainer}>
          <div className={iconBackground}>
            <SlDiamond size={20} color={colors.background} />
          </div>
          <div>
            <p className={cardTitleText}>Contorno e Elegância</p>
            <p className={cardDescriptionText}>Rosto definido e sofisticado.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
